
import { defineComponent } from 'vue';
// importing components
import FormComponent from '../components/Form.vue';
import Task from '../components/Task.vue';
import Box from '../components/Box.vue';
import ITask from '../interfaces/ITask';

export default defineComponent({
  name: 'TasksView',
  components: {
    FormComponent,
    Task,
    Box
  },
  // defining states
  data() {
    return {
      // returns an Array of Tasks
      tasks: [] as ITask[],
    };
  },
  // checks if the list of tasks is empty
  computed: {
    isListEmpty(): boolean {
      return this.tasks.length === 0;
    }
  },
  methods: {
    saveTask(task: ITask) {
      this.tasks.push(task);
    },
  }
});
